/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserEntitlementsRelation} from '../models/UpdateUserEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkDischargeUserEntitlements$Request {
    updateUserEntitlementsRelation: UpdateUserEntitlementsRelation;
    reason?: string;
}

export interface BulkDischargeUserEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkDischargeUserEntitlementsRequest = createAction<PayloadData<void, BulkDischargeUserEntitlements$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__BULK_DISCHARGE_USER_ENTITLEMENTS__REQUEST');
export const bulkDischargeUserEntitlementsSuccess = createAction<PayloadData<string, BulkDischargeUserEntitlements$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__BULK_DISCHARGE_USER_ENTITLEMENTS__SUCCESS');
export const bulkDischargeUserEntitlementsFailure = createAction<PayloadData<Error, BulkDischargeUserEntitlements$Request, true>>('BULK_DISCHARGE_USER_ENTITLEMENTS__BULK_DISCHARGE_USER_ENTITLEMENTS__FAILURE');

export const bulkDischargeUserEntitlementsActions = [
    bulkDischargeUserEntitlementsRequest,
    bulkDischargeUserEntitlementsSuccess,
    bulkDischargeUserEntitlementsFailure
] as const;

/**
 * @param {UpdateUserEntitlementsRelation} meta.updateUserEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkDischargeUserEntitlements = (meta: BulkDischargeUserEntitlements$Request, config?: BulkDischargeUserEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkDischargeUserEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeUserEntitlementsProgress$Request {
    id: string;
}

export interface GetDischargeUserEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeUserEntitlementsProgressRequest = createAction<PayloadData<void, GetDischargeUserEntitlementsProgress$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__REQUEST');
export const getDischargeUserEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetDischargeUserEntitlementsProgress$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getDischargeUserEntitlementsProgressFailure = createAction<PayloadData<Error, GetDischargeUserEntitlementsProgress$Request, true>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__FAILURE');

export const getDischargeUserEntitlementsProgressActions = [
    getDischargeUserEntitlementsProgressRequest,
    getDischargeUserEntitlementsProgressSuccess,
    getDischargeUserEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeUserEntitlementsProgress = (meta: GetDischargeUserEntitlementsProgress$Request, config?: GetDischargeUserEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeUserEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDischargeUserEntitlementsResult$Request {
    id: string;
}

export interface GetDischargeUserEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDischargeUserEntitlementsResultRequest = createAction<PayloadData<void, GetDischargeUserEntitlementsResult$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_RESULT__REQUEST');
export const getDischargeUserEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetDischargeUserEntitlementsResult$Request>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_RESULT__SUCCESS');
export const getDischargeUserEntitlementsResultFailure = createAction<PayloadData<Error, GetDischargeUserEntitlementsResult$Request, true>>('BULK_DISCHARGE_USER_ENTITLEMENTS__GET_DISCHARGE_USER_ENTITLEMENTS_RESULT__FAILURE');

export const getDischargeUserEntitlementsResultActions = [
    getDischargeUserEntitlementsResultRequest,
    getDischargeUserEntitlementsResultSuccess,
    getDischargeUserEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDischargeUserEntitlementsResult = (meta: GetDischargeUserEntitlementsResult$Request, config?: GetDischargeUserEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getDischargeUserEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

